<template>
<div id="reach">
<v-app id="inspire">
      <v-container
        fluid
        style="min-height: 0;"
        grid-list-lg
        text-xs-center
      >
        <v-layout row wrap>
          <v-flex xl12 lg12 sm12 xs12>
          <v-card-text>
            <h4 style="text-align: center; margin: 0;"><span style="color: rgba(0,0,0,1); font-weight:bold;"> <span>Amarthithi-2021</span></span></h4>
            <h3 style="text-align: center; margin: 0;"><span style="color: rgba(0,0,0,1); font-weight:bold;"> <span>Virtual Program</span></span></h3>
            <p style="margin: 0;"><strong>🌹Jai Meher Baba! 🌹</strong></p>
            <p style="text-align:justify">Beloved Baba's 52nd Amartithi will be conducted online as announced.</p>
            <p style="text-align: left; margin: 0;"><i>Start Time:</i> 12:30 hrs IST, 30-Jan-2021.</p>
            <p style="text-align: left;"><i>End Time:</i> 04:00 hrs IST, 01-Feb-2021.</p>
            <p style="text-align: left; word-break: break-word !important;">Watch the program at: <a href="https://avatarmeherbabatrust.org/index.php/avatar-meher-baba-virtual-amartithi-2021/" target="_blank">https://avatarmeherbabatrust.org/index.php/avatar-meher-baba-virtual-amartithi-2021/</a></p>
            <p style="text-align: left; margin: 0;">Alternately, please navigate through these links:</p>
            <p style="text-align: left; margin: 0; word-break: break-word !important;">1) <a href="https://www.youtube.com/c/AvatarMeherBabaMeherabadStreams/live" target="_blank">https://www.youtube.com/c/AvatarMeherBabaMeherabadStreams/live</a></p>
            <p style="text-align: left; word-break: break-word !important;">(broadcast may switch to <a href="http://www.youtube.com/c/MeherChannel/live" target="_blank">http://www.youtube.com/c/MeherChannel/live</a> in case of any disruption)</p>
            <p style="text-align: left; word-break: break-word !important;">2) <a href="https://www.facebook.com//chirag.gehlot.395/videos/10157831724552196/" target="_blank">https://www.facebook.com//chirag.gehlot.395/videos/10157831724552196/</a></p>
            <p>🌹Avatar Meher Baba Ki Jai!🌹</p>
          </v-card-text>

        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</div>
</template>
<script>
  export default {
    methods: {
    }
  }
</script>
<style>

  #reach {
    background-image: linear-gradient(rgba(218, 255, 199,0.8),rgba(218, 255, 199,0.8)), url("/static/doc-images/lists/biobg.png");
    background-size: cover;
  }
p{
  color: black;
  font-weight: bold;
}

#button {
  background-color: rgba(146, 182, 209,0.8);
  margin: auto;
  width: 32%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// amartithi-2021.vue?777109f3